var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating-save"},[_c('button',{staticClass:"button save-btn",class:{ 'is-loading': _vm.isSaving, 'enabled': _vm.isDirty },on:{"click":function($event){return _vm.$emit('save')}}},[_vm._v(" Save ")])])}
var staticRenderFns = []

export { render, staticRenderFns }